import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import ModuleContext from '../../../CMFW/context/ModuleContext';
import TrainerSegmentNew from './TrainerSegmentNew';
import TrainerSegmentListCard from './TrainerSegmentListCard';
import { FormControlLabel, Switch } from '@material-ui/core';
import { EditorRow } from '../../../components/common/styles';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import TrainerModel from '../../../models/TrainerModel';
import { ITrainerEdit } from '../../../types/trainer';

export type IProps = {
  onEditSegment: (exerciseId: number) => void;
  editingSegmentId?: number;
};

const TrainerSegmentList: React.FC<IProps> = (props) => {
  const [dnd, setDnd] = useState(false);
  const module = useContext(ModuleContext) as TrainerModel;
  const item = module.itemUpdated as ITrainerEdit;

  const onEditSegment = (exerciseId: number) => {
    props.onEditSegment(exerciseId);
  };

  return (
    <Wrapper>
      <DragDropContext onDragEnd={module.onDragEndSegment.bind(module)}>
        <Droppable isDropDisabled={!dnd} droppableId={'Trainer'} direction={'vertical'}>
          {(provided) => (
            <DropWrapper {...provided.droppableProps} ref={provided.innerRef}>
              {item.segments.map((segment, index) => (
                <TrainerSegmentListCard
                  segment={segment}
                  index={index}
                  dnd={dnd}
                  editing={segment.id === props.editingSegmentId}
                  key={`trainerSegment-${segment.id}`}
                  onEditSegment={onEditSegment}
                />
              ))}
            </DropWrapper>
          )}
        </Droppable>
      </DragDropContext>
      <EditorRow>
        <TrainerSegmentNew />
        <FormControlLabel
          control={
            <Switch
              checked={dnd}
              onChange={() => setDnd(!dnd)}
              color="primary"
              size="small"
              disabled={item.segments.length < 2}
            />
          }
          label="DND"
        />
      </EditorRow>
    </Wrapper>
  );
};

export default TrainerSegmentList;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  width: 280px;
`;

const DropWrapper = styled.div`
  height: 100%;
  overflow: auto;
`;
